import * as React from 'react';

import * as styles from './LowRateMortgagePromos.css';
import { ILowRateMortgagePromo } from '../../types/promosPage';
import { PromoItem } from '../PromoItem';
import { StandardBottomContent } from '../PromoItem/parts';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';
import { Section } from '../Section';
import { VerticalSlider } from '../VerticalSlider';

interface ILowRateMortgagePromosProps {
  onPromoClick(promo: ILowRateMortgagePromo): void;
  promoList: ILowRateMortgagePromo[];
  title: string;
}

export const LowRateMortgagePromos: React.FC<ILowRateMortgagePromosProps> = ({ onPromoClick, promoList, title }) => {
  return (
    <Section title={title} data-testid="LowRateMortgagePromos">
      <VerticalSlider itemGap="16px" rightArrow={RoundArrowRight} leftArrow={RoundArrowLeft}>
        {promoList.map(promo => (
          <div className={styles['slide']} key={promo.uniqueId}>
            <PromoItem
              promo={promo}
              bottomContent={<StandardBottomContent promoProps={promo.promoProps} />}
              onClick={() => onPromoClick(promo)}
            />
          </div>
        ))}
      </VerticalSlider>
    </Section>
  );
};
